var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66671 1.89136V5.33348C9.66671 5.80018 9.66671 6.03354 9.75754 6.2118C9.83743 6.3686 9.96491 6.49609 10.1217 6.57598C10.3 6.66681 10.5333 6.66681 11 6.66681H14.4422M9.66671 1.66675H5.33337C3.93324 1.66675 3.23318 1.66675 2.6984 1.93923C2.22799 2.17892 1.84554 2.56137 1.60586 3.03177C1.33337 3.56655 1.33337 4.26662 1.33337 5.66675V14.3334C1.33337 15.7335 1.33337 16.4336 1.60586 16.9684C1.84554 17.4388 2.22799 17.8212 2.6984 18.0609C3.23318 18.3334 3.93324 18.3334 5.33337 18.3334H10.6667C12.0668 18.3334 12.7669 18.3334 13.3017 18.0609C13.7721 17.8212 14.1545 17.4388 14.3942 16.9684C14.6667 16.4336 14.6667 15.7335 14.6667 14.3334V6.66675L9.66671 1.66675ZM7.99776 9.85891C7.33131 9.10142 6.21996 8.89765 5.38494 9.59129C4.54992 10.2849 4.43236 11.4447 5.08811 12.265C5.74385 13.0854 7.99776 15.0001 7.99776 15.0001C7.99776 15.0001 10.2517 13.0854 10.9074 12.265C11.5632 11.4447 11.4599 10.2776 10.6106 9.59129C9.76121 8.90495 8.66421 9.10142 7.99776 9.85891Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonal);
export default __webpack_public_path__ + "static/media/personal.e407275a3a1a7f61b510b69e7ed5fa15.svg";
export { ForwardRef as ReactComponent };